module.exports = __webpack_public_path__ + "3b913d24.png";